import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-outfit font-bold mb-8">Refund & Cancellation Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: July 2026</p>

        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">1. Digital Products</h2>
            <p>
              All test series sold on Pinaka Education are digital products. Once a test series is purchased and access is granted, the sale is considered final.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">2. Refund Eligibility</h2>
            <p>Refunds may be considered in the following cases:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>Duplicate payment (charged twice for the same test series).</li>
              <li>Technical issue preventing access to purchased content for an extended period.</li>
              <li>Payment made but access not granted within 24 hours.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">3. Non-Refundable Cases</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Change of mind after purchase.</li>
              <li>Test already attempted (even partially).</li>
              <li>Dissatisfaction with question difficulty or content.</li>
              <li>Account suspension due to terms violation.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">4. How to Request a Refund</h2>
            <p>
              To request a refund, email us at{' '}
              <a href="mailto:support@pinakaclasses.com" className="text-primary hover:underline">
                support@pinakaclasses.com
              </a>{' '}
              with:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>Your registered email address</li>
              <li>Payment transaction ID</li>
              <li>Reason for refund request</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">5. Processing Time</h2>
            <p>
              Approved refunds will be processed within 5-7 business days. The refund will be credited to the original payment method.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">6. Free Trials</h2>
            <p>
              We offer free trial tests so you can evaluate our content before purchasing. We encourage trying the free test before making a purchase.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
